import badgeStyles from '../Badge/Badge.module.css';
import { CloseIcon } from '../Icon/CloseIcon';
import styles from './Pill.module.css';
import classNames from 'classnames';

interface Props {
  onRemove: () => void;
  label: string;
}

export function Pill({ label, onRemove }: Props) {
  return (
    <span className={classNames(badgeStyles.badge, badgeStyles['variant-default'], styles.pill)}>
      {label}
      <button type="button" onClick={onRemove}>
        <CloseIcon />
      </button>
    </span>
  );
}
